import * as Crypto from 'expo-crypto';

const CODE_VERIFIER_LENGTH = 64;
const UNRESERVED_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';

const generateCodeVerifier = (): string => {
  const randomBytes = Crypto.getRandomBytes(CODE_VERIFIER_LENGTH);

  return Array.from(randomBytes)
    .map((byte) => UNRESERVED_CHARS[byte % UNRESERVED_CHARS.length])
    .join('');
};

const toBase64Url = (hex: string): string => {
  const bytes = new Uint8Array(hex.match(/.{1,2}/g)!.map((byte) => parseInt(byte, 16)));

  const base64 = btoa(String.fromCharCode(...bytes));

  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

const generateCodeChallenge = async (verifier: string): Promise<string> => {
  const digest = await Crypto.digestStringAsync(Crypto.CryptoDigestAlgorithm.SHA256, verifier);

  return toBase64Url(digest);
};

export { generateCodeChallenge, generateCodeVerifier };
